import { Outlet } from "react-router-dom"

export const InvoiceContainer = () => {
    return (
        <Outlet />
    )
}
